
export const headerData = {
    name: 'Lu Myeong',
    title: "Hello! I am",
    desciption: "Hello! I am a professional and passionate programmer in my daily life. A quick learner with a self-learning attitude. I love to learn and explore new technologies and am Passionate about Problem Solving. ",
    image: '1.jpg',
    imagebw: 'https://i.ibb.co/Cw2Xp90/abu-said-bw.jpg',
    resumePdf: 'resume.pdf'
}
